import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { OtpComponent } from './pages/otp/otp.component';
import { DashboardComponent } from './pages/dashboard/dashboard/dashboard.component';
import { SubadminMgtComponent } from './pages/dashboard/sub-admin/sub-admin-mgt/subadmin-mgt.component';
import { AddSubadminComponent } from './pages/dashboard/sub-admin/add-sub-admin/add-subadmin.component';
import { ViewSubadminComponent } from './pages/dashboard/sub-admin/view-sub-admin/view-subadmin.component';
import { EditSubadminComponent } from './pages/dashboard/sub-admin/edit-sub-admin/edit-subadmin.component';
import { MyProfileComponent } from './pages/dashboard/my-profile/my-profile.component';
import { ChangePasswordComponent } from './pages/dashboard/change-password/change-password.component';
import { PatientMgtComponent } from './pages/dashboard/patient-management/patient-mgt/patient-mgt.component';
import { AddPatientComponent } from './pages/dashboard/patient-management/add-patient/add-patient.component';
import { EditPatientComponent } from './pages/dashboard/patient-management/edit-patient/edit-patient.component';
import { ViewPatientComponent } from './pages/dashboard/patient-management/view-patient/view-patient.component';
import { TherapistMgtComponent } from './pages/dashboard/therapist/therapist-mgt/therapist-mgt.component';
import { AddTherapistComponent } from './pages/dashboard/therapist/add-therapist/add-therapist.component';
import { EditTherapistComponent } from './pages/dashboard/therapist/edit-therapist/edit-therapist.component';
import { StaffAvailabilityComponent } from './pages/dashboard/therapist/staff-availability/staff-availability.component';
import { ProgramMgtComponent } from './pages/dashboard/program/program-mgt/program-mgt.component';
import { AddProgramComponent } from './pages/dashboard/program/add-program/add-program.component';
import { EditProgramComponent } from './pages/dashboard/program/edit-program/edit-program.component';
import { TransactionMgtComponent } from './pages/dashboard/transaction-mgt/transaction-mgt.component';
import { AssessmentFormComponent } from './pages/dashboard/assessments/assessment-form/assessment-form.component';
import { StaticContentMgtComponent } from './pages/dashboard/static-content/static-content-mgt/static-content-mgt.component';
import { EditStaticContentComponent } from './pages/dashboard/static-content/edit-static-content/edit-static-content.component';
import { FaqMgtComponent } from './pages/dashboard/static-content/faq-mgt/faq-mgt/faq-mgt.component';
import { AfaqComponent } from './pages/dashboard/static-content/faq-mgt/add-faq/add-faq.component';
import { EditFaqComponent } from './pages/dashboard/static-content/faq-mgt/edit-faq/edit-faq.component';
import { ViewFaqComponent } from './pages/dashboard/static-content/faq-mgt/view-faq/view-faq.component';
import { NotificationComponent } from './pages/dashboard/notifications/notification.component';
import { LibraryMgtComponent } from './pages/dashboard/library/library-mgt/library-mgt.component';
import { AddLibraryComponent } from './pages/dashboard/library/add-library/add-library.component';
import { ViewLibraryComponent } from './pages/dashboard/library/view-library/view-library.component';
import { ReviewMgtComponent } from './pages/dashboard/review/review-mgt/review-mgt.component';
import { ViewReviewComponent } from './pages/dashboard/review/view-review/view-review.component';
import { ChatComponent } from './pages/dashboard/chat/chat.component';
import { JournalMgtComponent } from './pages/dashboard/journal/journal-mgt/journal-mgt.component';
import { ViewJournalComponent } from './pages/dashboard/journal/view-journal/view-journal.component';
import { EditJournalComponent } from './pages/dashboard/journal/edit-journal/edit-journal.component';
import { EditAssessmentComponent } from './pages/dashboard/assessments/edit-assessment/edit-assessment.component';
import { EditQuestionnaireComponent } from './pages/dashboard/assessments/edit-questionnaire/edit-questionnaire.component';
import { QueryMgtComponent } from './pages/dashboard/query-management/query-mgt/query-mgt.component';
import { ViewQueryComponent } from './pages/dashboard/query-management/view-query/view-query.component';
import { ProgramTypeMgtComponent } from './pages/dashboard/program-type-mgt/program-type-mgt.component';
import { AddProgramTypeComponent } from './pages/dashboard/program-type-mgt/add-program-type/add-program-type.component';
import { EditProgramTypeComponent } from './pages/dashboard/program-type-mgt/edit-program-type/edit-program-type.component';
import { ViewTherapistComponent } from './pages/dashboard/therapist/view-therapist/view-therapist.component';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent  },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password/:id', component: ResetPasswordComponent },
  {path : 'otp/:id' , component : OtpComponent},
  {path :'dashboard' , component : DashboardComponent ,canActivate: [AuthGuard]},
  // My Profile 
  {path : 'my-profile',component: MyProfileComponent , canActivate: [AuthGuard]},
  //  Change password 
  {path : 'change-password',component : ChangePasswordComponent , canActivate: [AuthGuard]},
  //Subadmin Management
  {path :'subadmin-mgt',component : SubadminMgtComponent , canActivate: [AuthGuard]},
  {path :'add-subadmin',component: AddSubadminComponent , canActivate: [AuthGuard]},
  {path :'view-subadmin/:id',component : ViewSubadminComponent , canActivate: [AuthGuard]},
  {path : 'edit-subadmin/:id',component : EditSubadminComponent , canActivate: [AuthGuard]},

  // Patient Management

  {path : 'patient-mgt',component : PatientMgtComponent , canActivate: [AuthGuard]},
  {path :'add-patient',component : AddPatientComponent , canActivate: [AuthGuard]},
  {path :'edit-patient',component : EditPatientComponent , canActivate: [AuthGuard]},
  {path : 'view-patient',component : ViewPatientComponent , canActivate: [AuthGuard]},

    // Therapist Management
  {path : 'therapist' ,component : TherapistMgtComponent , canActivate: [AuthGuard]},
  {path : 'add-therapist',component : AddTherapistComponent , canActivate: [AuthGuard]},
  {path : 'edit-therapist/:id',component : EditTherapistComponent , canActivate: [AuthGuard]},
  {path : 'staff-availability',component : StaffAvailabilityComponent , canActivate: [AuthGuard]},
  {path : 'view-therapist/:id' , component : ViewTherapistComponent , canActivate: [AuthGuard]} ,

  // Program Management
  {path :'program-mgt',component : ProgramMgtComponent , canActivate: [AuthGuard]},
  {path :'add-program',component :AddProgramComponent , canActivate: [AuthGuard]},
  {path :'edit-program/:id',component : EditProgramComponent , canActivate: [AuthGuard]},

  // Transaction management
  {path :'transaction-mgt',component : TransactionMgtComponent , canActivate: [AuthGuard]},
  
  // Assessments and Forms 
  {
    path :'assessment',component : AssessmentFormComponent , canActivate: [AuthGuard]
  },
  {path :'edit-assessment/:id',component : EditAssessmentComponent , canActivate: [AuthGuard]},
  {path : 'edit-question/:id' , component : EditQuestionnaireComponent , canActivate: [AuthGuard]},

  // Static-content-management
  
  {path : 'static-content',component : StaticContentMgtComponent , canActivate: [AuthGuard]},
  {path :'edit-static/:id',component : EditStaticContentComponent , canActivate: [AuthGuard] }, 
  
  // Faq mangement
  {path :"faq-mgt",component : FaqMgtComponent , canActivate: [AuthGuard]},
  {path : 'add-faq',component : AfaqComponent , canActivate: [AuthGuard]},
  {path : 'edit-faq/:id',component : EditFaqComponent , canActivate: [AuthGuard]},
  {path : 'view-faq/:id',component : ViewFaqComponent , canActivate: [AuthGuard]},
  // Notifications 
  {path :'notification' ,component : NotificationComponent , canActivate: [AuthGuard]},

  // Library management
  {path: 'library-mgt',component : LibraryMgtComponent , canActivate: [AuthGuard]},
  {path :'add-library',component : AddLibraryComponent , canActivate: [AuthGuard]},
  {path : 'view-library/:id',component : ViewLibraryComponent , canActivate: [AuthGuard]},
  // Review Management
  {path :'review-mgt', component : ReviewMgtComponent , canActivate: [AuthGuard]},
  {path :'view-review/:id',component : ViewReviewComponent , canActivate: [AuthGuard]},
  // Chat Management
  {path : 'chat',component : ChatComponent , canActivate: [AuthGuard]},
  // journal management
  {path : "journal-mgt" , component : JournalMgtComponent , canActivate: [AuthGuard]},
  {path : 'view-journal/:id',component : ViewJournalComponent , canActivate: [AuthGuard]},
  {path : "edit-journal/:id", component : EditJournalComponent , canActivate: [AuthGuard]},
  // query management 
  {path : 'query-mgt', component : QueryMgtComponent , canActivate: [AuthGuard]},
  {path : 'view-query/:id' , component : ViewQueryComponent , canActivate: [AuthGuard]},

  // program type management 
   
  {path : "program-type-mgt" , component : ProgramTypeMgtComponent , canActivate: [AuthGuard]},
  {path :"add-program-type", component: AddProgramTypeComponent , canActivate: [AuthGuard]},
  {path :"edit-program-type/:id",component : EditProgramTypeComponent , canActivate: [AuthGuard]},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
